import { apiClient } from '../../../services/api/client';

export const errorsAPI = {
  // Get error summary
  getErrorSummary: (params = {}) => 
    apiClient.get('/api/v1/errors/', { params }),
  
  // Get errors by endpoint
  getErrorsByEndpoint: (params) => 
    apiClient.get('/api/v1/errors/by-endpoint', { params }),
  
  // Get errors by staff member
  getErrorsByStaffMember: (staffMemberId, params = {}) => 
    apiClient.get(`/api/v1/errors/by-staff-member/${staffMemberId}`, { params }),
  
  // Get errors by department
  getErrorsByDepartment: (departmentId, params = {}) => 
    apiClient.get(`/api/v1/errors/by-department/${departmentId}`, { params }),
  
  // Get error details
  getErrorDetails: (errorId) => 
    apiClient.get(`/api/v1/errors/${errorId}`),
  
  // Cleanup old errors
  cleanupOldErrors: (params = {}) => 
    apiClient.delete('/api/v1/errors/cleanup', { params }),
  
  // Count errors by endpoint
  countErrorsByEndpoint: (params) => 
    apiClient.get('/api/v1/errors/count/endpoint', { params }),
  
  // Count errors by code
  countErrorsByCode: (params) => 
    apiClient.get('/api/v1/errors/count/code', { params }),
};